import { useQuery } from '@tanstack/react-query';
import { fetchInvoices, getInvoiceFileLink } from 'api/invoices';

export type useInvoicesProps = {
  period: string | null;
  campaignId: number | null;
  offset: number;
};

export const useInvoices = ({ period, campaignId, offset }: useInvoicesProps) => {
  const getInvoicesQuery = useQuery({
    queryKey: ['invoices', period, campaignId, offset],
    queryFn: () => fetchInvoices({ period, campaignId, offset }),
  });

  return {
    getInvoicesQuery,
    getInvoiceFileLink,
  };
};
